import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaiVietFileDinhKem } from 'src/app/shared/BaiVietFileDinhKem.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class BaiVietFileDinhKemService extends BaseService{

    DisplayColumns001: string[] = ['Name', 'FileName', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "BaiVietFileDinhKem";
    }
}

